import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import CopyCard from "../components/CopyCard";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faPlus, faXmark, faCircleNotch} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import Select from "react-select";

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Copyexpert() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [trader_photo, setTrader_photo] = useState();
  const [trader_name, setTrader_name] = useState();
  const [win, setWin] = useState();
  const [loss, setLoss] = useState();
  const [win_rate, setWin_rate] = useState();
  const [profit_share, setProfit_share] = useState();
  const [price, setPrice] = useState();
  const [files, setFiles] = useState([]);
  const [badge_color, setBadge_color] = useState();
  const [activeTab, setActiveTab] = useState("top");
  const badgeoption = [
    { value: 'blue', label: 'Blue' },
    { value: 'gold', label: 'Gold' }
  ];
  useEffect(() => {
    if(trader_photo && trader_name && win && loss && win_rate && profit_share && price && badge_color){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [trader_photo, trader_name, win, loss, win_rate, profit_share, price, badge_color]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [copyExperts, setCopyExperts] = useState([]);
  const [myCopy, setMyCopy] = useState([]);
  useEffect(() => {
    const fetchCopyData = async () => {
    try {
      const myCopyRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fetchMyCopytrade: true })
      });
      const myCopyData = await myCopyRes.json();
      if (myCopyData.status !== "success") {
        toast.error('Error fetching your copytrade data!');
        return;
      }
      const myCopyList = myCopyData.copytrade;
      setMyCopy(myCopyList);
      const allExpertsRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fetchCopytrade: true })
      });
      const allExpertsData = await allExpertsRes.json();
      if (allExpertsData.status !== "success") {
        toast.error('Error fetching expert traders!');
        return;
      }
      const expertList = allExpertsData.copytrade;
      const updatedExperts = expertList.map(trader => {
        const myCopy = myCopyList.find(item => item.trader_id === trader.trade_id);
        return {
          ...trader,
          copy: !!myCopy,
          pending: myCopy?.status == 2
        };
      });
      setCopyExperts(updatedExperts);
    } catch (err) {
      console.error('Error fetching copytrade data:', err);
      toast.error('An unexpected error occurred!');
    }
  };
    if (user) {
      fetchCopyData();
    }
  }, [user]);
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const AddCopytrade = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addcopytrade: true, trader_photo : trader_photo, trader_name : trader_name, win : win, loss : loss, win_rate : win_rate, profit_share : profit_share, price : price, badge_color: badge_color})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "copyexpert";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Copy Experts" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Copy Experts" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="d-flex align-items-center justify-content-between mt-2">
              <div className="ms-2">
                <h6 className="mb-0 text-white mt-3 text-uppercase" style={{fontSize:'20px', fontWeight:'900'}}>Copy Trading</h6>
                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Follow the world's top crypto traders and copy their trades with on click</p>
              </div>
              {user?.user_type === "adminface" && (
                <div className="myBtn d-inline-block bg-prime px-3" style={{fontSize: '14px'}} onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} /> Add Expert</div>
              )}
            </div>
            <div className="row">
              {copyExperts.map((expert) => (
                <div className="col-xxl-3 col-lg-4 col-6 col-12 g-4">
                    <CopyCard key={expert.id} trade_id={expert.trade_id} pending={expert.pending} info={expert.info} photo={expert.trader_photo} image={<img src={`/uploads/${expert.trader_photo}`} alt={expert.trader_name} style={{height:'100%',width:'100%',objectFit:'cover'}} />} name={expert.trader_name} winrate={expert.win_rate} profit={expert.profit_share} win={expert.win} loss={expert.loss} copy={expert.copy} price={expert.price} badge_color={expert.badge_color}/>
                </div>
              ))}
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Add expert</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Expert image</label>
            <FilePond
              files={files}
              onupdatefiles={setFiles}
              allowMultiple={false}
              maxFiles={3}
              name="file"
              labelIdle="Click here to upload payment proof"
              server={{
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                  const formData = new FormData();
                  formData.append("file", file);
                  const request = new XMLHttpRequest();
                  request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    const res = JSON.parse(request.responseText);
                    if (res.success) {
                      setTrader_photo(res.filename);
                      load(res.filename);
                    } else {
                      error(res.error || "Upload failed");
                    }
                  };
                  request.onerror = () => {
                    error("Upload error");
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    }
                  };
                },
                revert: (serverId, load, error) => {
                  fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filename: trader_photo })
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.success) {
                        setTrader_photo("");
                        setFiles([]);
                        load();
                      } else {
                        error(data.error || "Failed to delete file");
                      }
                    })
                    .catch(() => {
                      error("Delete request failed");
                    });
                }
              }}
            />
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Expert Name:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder="Gunbot"
                  className="inputNone"
                  value={trader_name}
                  onChange={(e) => setTrader_name(e.target.value)}
                />
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Win:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={win}
                      onChange={(e) => setWin(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    WIN
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Loss:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={loss}
                      onChange={(e) => setLoss(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    LOSS
                    </div>
                </div>
              </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Win Rate:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="40"
                  className="inputNone"
                  value={win_rate}
                  onChange={(e) => setWin_rate(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  %
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Profit Share:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="2"
                  className="inputNone"
                  value={profit_share}
                  onChange={(e) => setProfit_share(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  %
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Price:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="2"
                  className="inputNone"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  USD
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Badge:</label>
            <Select 
                options={badgeoption} 
                value={badgeoption.find((opt) => opt.value === badge_color)}
                onChange={(selected) => {
                  setBadge_color(selected.value); 
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddCopytrade : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
        </Modal>
      </div>
    </div>
  )
}

export default Copyexpert